import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Store } from '@ngrx/store';
import { Permissions, selectPermissions, selectUser } from '@lmc-app/store';
import { Observable } from 'rxjs';
import { User } from '@lmc-app/shared/interface/user.interface';
import { API } from '@lmc-app/core/constants/api.constant';
import { environment } from '@lmc-env/environment';

@Injectable({
	providedIn: 'root',
})
export class UserService {
	user$: Observable<User>;
	permissions$: Observable<Permissions>;

	constructor(
		private readonly store: Store,
		private readonly http: HttpClient
	) {
		this.user$ = this.store.select(selectUser);
		this.permissions$ = this.store.select(selectPermissions);
	}

	/**
	 * Get current user information
	 *
	 * This endpoint:
	 * 1. Validates the access token from HttpOnly cookies
	 * 2. Returns user data if token is valid
	 * 3. Returns 401 if token is invalid/expired (triggers auto-refresh in interceptor)
	 *
	 * Used for session initialization (new tab, page refresh)
	 *
	 * Note: No retry logic here because:
	 * - 401 errors are handled by auth-error.interceptor (token refresh)
	 * - 4xx/5xx errors should not be retried (they won't succeed)
	 * - Network errors will timeout via timeout.interceptor
	 */
	getUserMe(): Observable<User> {
		return this.http.get<User>(API.USER.ME);
	}

	getUsers(): Observable<User[]> {
		return this.http.get<User[]>(`${environment.DO_URL}/v2/users`);
	}
}
